import * as yup from 'yup'
import { RecipientRow } from '../../generated/api/chat-recipients'

export const roomMessageSchema = yup
  .object({
    mediaIds: yup.array(yup.string().required()),
    message: yup.string().when('mediaIds', {
      is: (val: string[] | undefined) => !val || val.length === 0,
      then: (schema) => schema.trim().required(),
    }),
  })
  .required()

export const chatMessageSchema = yup
  .object({
    recipients: yup
      .array(yup.mixed<RecipientRow>().required())
      .when('isGroupchat', {
        is: true,
        then: (schema) => schema.min(1),
      }),
    authorId: yup.string().required(),
    mediaIds: yup.array(yup.string().required()),
    message: yup.string().when('mediaIds', {
      is: (val: string[]) => {
        return val.length === 0
      },
      then: (schema) => schema.required(),
    }),
    isGroupchat: yup.boolean().required(),
    isBoardChat: yup.boolean().required(),
    groupChatTitle: yup
      .string()
      .when('isGroupchat', {
        is: true,
        then: (schema) => schema.min(1),
      })
      .when('isBoardChat', {
        is: true,
        then: (schema) => schema.min(1),
      }),
    society: yup.string(),
    isPrivate: yup.string(),
  })
  .required()
